import React from 'react'

const ErrorPage = () => {
  return (
    <>
         {/* <!--Start Error Page--> */}
        <section className="error-page">
            <div className="error-page__bg" style={{backgroundImage: "url(/assets/images/backgrounds/page-header-img4.jpg)"}}>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="error-page__wrapper text-center">
                            <div className="error-page__content">
                                <h2>4<span>0</span>4</h2>
                                <h3>Oops... Page Not Found!</h3>
                                <p>Try using the button below to go to main page of the site</p>

                                <div className="error-page__btn">
                                    <a href="/" className="thm-btn">Back to Home</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* <!--End Error Page--> */}
    </>
  )
}

export default ErrorPage